import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReviewTabs from './ReviewTabs';

export default function MonitorReport() {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('repo'); // 'repo', 'pr', 'author'

  useEffect(() => {
    axios.get('/code-review/monitor-report')
      .then((res) => {
        setReportData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response?.data?.error || err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2>Monitor Report</h2>
        <p>Overview of PR lifecycle and review comment resolution.</p>
      </div>
      <div className="page-body">
        <ReviewTabs />

        {loading && <div className="spinner" />}
        {error && <div className="error-msg">{error}</div>}
        
        {reportData && (
          <div className="card" style={{ padding: '16px 20px' }}>
            <div style={{ marginBottom: '20px' }}>
              <button className={`btn ${activeTab === 'repo' ? 'btn-primary' : 'btn-default'}`} onClick={() => setActiveTab('repo')} style={{ marginRight: 10 }}>By Repository</button>
              <button className={`btn ${activeTab === 'pr' ? 'btn-primary' : 'btn-default'}`} onClick={() => setActiveTab('pr')} style={{ marginRight: 10 }}>By PR</button>
              <button className={`btn ${activeTab === 'author' ? 'btn-primary' : 'btn-default'}`} onClick={() => setActiveTab('author')}>By Author</button>
            </div>

      {activeTab === 'repo' && (
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #ccc' }}>
              <th style={{ padding: 8 }}>Repository</th>
              <th style={{ padding: 8 }}>Total PRs</th>
              <th style={{ padding: 8 }}>Merged PRs</th>
              <th style={{ padding: 8 }}>Abandoned PRs</th>
              <th style={{ padding: 8 }}>Total Findings</th>
              <th style={{ padding: 8 }}>Acted Upon</th>
              <th style={{ padding: 8 }}>Resolution Rate</th>
            </tr>
          </thead>
          <tbody>
            {reportData.by_repo.map((r, i) => {
              const rate = r.total_findings ? Math.round((r.acted_upon_findings / r.total_findings) * 100) : 0;
              return (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: 8 }}>{r.repo}</td>
                  <td style={{ padding: 8 }}>{r.total_prs}</td>
                  <td style={{ padding: 8 }}>{r.merged_prs}</td>
                  <td style={{ padding: 8 }}>{r.abandoned_prs}</td>
                  <td style={{ padding: 8 }}>{r.total_findings}</td>
                  <td style={{ padding: 8 }}>{r.acted_upon_findings}</td>
                  <td style={{ padding: 8 }}>{rate}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {activeTab === 'pr' && (
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #ccc' }}>
              <th style={{ padding: 8 }}>Repository</th>
              <th style={{ padding: 8 }}>PR</th>
              <th style={{ padding: 8 }}>Author</th>
              <th style={{ padding: 8 }}>Status</th>
              <th style={{ padding: 8 }}>Findings</th>
              <th style={{ padding: 8 }}>Acted Upon</th>
              <th style={{ padding: 8 }}>Resolution Rate</th>
            </tr>
          </thead>
          <tbody>
            {reportData.by_pr.map((r, i) => {
              const rate = r.total_findings ? Math.round((r.acted_upon_findings / r.total_findings) * 100) : 0;
              return (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: 8 }}>{r.repo}</td>
                  <td style={{ padding: 8 }}>
                    <a href={r.pr_url} target="_blank" rel="noreferrer">#{r.pr_id}</a><br/>
                    <small>{r.pr_title}</small>
                  </td>
                  <td style={{ padding: 8 }}>{r.author}</td>
                  <td style={{ padding: 8 }}>{r.status}</td>
                  <td style={{ padding: 8 }}>{r.total_findings}</td>
                  <td style={{ padding: 8 }}>{r.acted_upon_findings}</td>
                  <td style={{ padding: 8 }}>{rate}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {activeTab === 'author' && (
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #ccc' }}>
              <th style={{ padding: 8 }}>Author</th>
              <th style={{ padding: 8 }}>Total PRs</th>
              <th style={{ padding: 8 }}>Total Findings</th>
              <th style={{ padding: 8 }}>Acted Upon</th>
              <th style={{ padding: 8 }}>Resolution Rate</th>
            </tr>
          </thead>
          <tbody>
            {reportData.by_author.map((r, i) => {
              const rate = r.total_findings ? Math.round((r.acted_upon_findings / r.total_findings) * 100) : 0;
              return (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: 8 }}>{r.author}</td>
                  <td style={{ padding: 8 }}>{r.total_prs}</td>
                  <td style={{ padding: 8 }}>{r.total_findings}</td>
                  <td style={{ padding: 8 }}>{r.acted_upon_findings}</td>
                  <td style={{ padding: 8 }}>{rate}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
          </div>
        )}
      </div>
    </div>
  );
}
